<template>
	<div class="ribbon-label">
		<div class="label">{{ translate("ui.new.non_translatable") }}</div>
	</div>
</template>

<script lang="ts" setup>
import { translate } from "@/utils/translate";
</script>

<style scoped lang="scss">
.ribbon-label {
	position: relative;
	--size: 0.75rem;
	filter: drop-shadow(0.0625rem 0.03125rem 0.0625rem black);
	// TODO doplnit grafikmi texturu
	background: #a30119;
	width: max-content;
	font-size: var(--size);
	line-height: var(--size);
	user-select: none;
	text-align: center;

	.label {
		color: #fff3dd;
		font-weight: 800;
		text-transform: uppercase;
	}

	&::after {
		display: block;
		position: absolute;
		right: calc(-0.7 * var(--size));
		bottom: 0;
		z-index: -1;
		border: calc(var(--size) / 2) solid #a30119;
		border-right-color: transparent;
		content: "";
	}
}
</style>
